module.exports = __webpack_public_path__ + "img/21d9d59.jpg";